var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommentWidgetIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "26px",
  height: "28px",
  viewBox: "0 0 26 28",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons_bookmarks-copy",
  transform: "translate(-271.000000, -395.000000)",
  fill: "#001246"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-14",
  transform: "translate(264.000000, 89.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11",
  transform: "translate(7.000000, 297.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_comment",
  transform: "translate(0.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.23404744,21.547 L21.2674828,21.547 C22.1009946,21.547 22.8181331,21.237 23.416909,20.617 C24.0146901,19.998 24.314078,19.269 24.314078,18.43 L24.314078,4.813 C24.314078,3.975 24.0146901,3.245 23.416909,2.625 C22.8181331,2.006 22.1009946,1.695 21.2674828,1.695 L4.73152257,1.695 C3.89801071,1.695 3.18186687,2.006 2.58309105,2.625 C1.98530987,3.245 1.68592196,3.975 1.68592196,4.813 L1.68592196,24.938 L7.23404744,21.547 Z M24.613466,1.422 C25.5374904,2.37 26,3.519 26,4.867 L26,18.375 C26,19.725 25.5374904,20.873 24.613466,21.82 C23.6884468,22.769 22.5734507,23.242 21.2674828,23.242 L7.66870696,23.242 L0,28 L0,4.867 C0,3.519 0.46151492,2.37 1.38653405,1.422 C2.31155318,0.475 3.42654935,0 4.73152257,0 L21.2674828,0 C22.5734507,0 23.6884468,0.475 24.613466,1.422 L24.613466,1.422 Z",
  id: "Fill-16"
}))))))));
export default SvgCommentWidgetIcon;